module.exports = __webpack_public_path__ + "static/media/pk4media-logo-white.5dabbc0b.svg";